import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const ViewDocs = ({ content }) => {
  return (
    <div className="view-concated-html mt-3">
      <ReactQuill
        id="featureDocumentation"
        name="featureDocumentation"
        className={`formInput`}
        placeholder={content ? "" : "No Content Availble"}
        value={content}
        readOnly
      />
    </div>
  );
};

export default ViewDocs;
